/**
 * When two directions are the same direction.
 *
 * This is the server's rule, not an approximation of it. A direction's identity is its hash, and
 * the hash is taken over the text with every whitespace character removed and the rest lower-cased
 * (`transformAndGenerateHash` in smartphos-core). `approved_direction` is keyed on that hash, so
 * "Take 1 tablet", "take 1 tablet" and "Take  1  Tablet" are one direction there — linking the
 * second to a sig that already has the first finds the existing link and does nothing.
 *
 * Which is exactly what went wrong: the screen staged the duplicate, listed it under Pending
 * changes, committed it, and reported success for a write that had merged into nothing. The
 * reviewer was told their change had been applied and it had not.
 *
 * Trailing full stops are NOT stripped here, deliberately. The sig's canonical form drops them and
 * a direction's hash does not, so "Take 1 tablet" and "Take 1 tablet." are two directions to the
 * server. Stripping them here would refuse an addition the server would have accepted.
 */
// eslint-disable-next-line import/prefer-default-export
export const toDirectionIdentity = (direction) =>
  String(direction ?? '')
    .replace(/\s+/g, '')
    .toLowerCase();
